import React from 'react';

const Breadcrumb = ({ path, onNavigate }) => {
  const segments = path ? path.split('/').filter(Boolean) : [];

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-2">
        <li className="breadcrumb-item">
          <a href="#!" onClick={(e) => { e.preventDefault(); onNavigate(''); }}>uploads</a>
        </li>
        {segments.map((segment, i) => {
          const segmentPath = segments.slice(0, i + 1).join('/');
          const isLast = i === segments.length - 1;
          return isLast ? (
            <li key={segmentPath} className="breadcrumb-item active" aria-current="page">{segment}</li>
          ) : (
            <li key={segmentPath} className="breadcrumb-item">
              <a href="#!" onClick={(e) => { e.preventDefault(); onNavigate(segmentPath); }}>{segment}</a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
